import { option } from "fp-ts";
import { isAFullName } from "./isAFullName";

export const isAFullNameOption = (text: unknown) => 
    isAFullName(text) ? 
        option.some(text) 
        : option.none
;